// extracted by mini-css-extract-plugin
export default {"ContainerCursor":"MessageCard_ContainerCursor__fpsjo","DividingLine":"MessageCard_DividingLine__keLOv"};